import React, {useMemo} from 'react';
import {hasAccessPermission} from '../../../common/permissions/validations';
import {paths} from '../../../common/dictionaries/urls';
import {resources, scopes} from '../../../common/permissions/dictionary';
import {connect} from 'react-redux';
import {Card, Header, Button} from 'semantic-ui-react';
import {ReactComponent as SortSvg} from './sort.svg';
import {ReactComponent as SortUpSvg} from './sortUp.svg';
import {ReactComponent as SortDownSvg} from './sortDown.svg';
import {useSortBy, useTable} from 'react-table';
import {validateEmptyFields, roundNumber} from '../../utils';
import {Actions} from '../../../common/actions';
import './vehiclesModel.scss';
import cloneDeep from 'lodash/cloneDeep';
import find from 'lodash/find';

class VehiclesModels extends React.Component {
  state = {
    'data': [],
    'columns': [
      {
        'Header': 'CÓDIGO',
        'accessor': 'idx',
        'Cell': (props) => this.renderEditable(props),
        'width': 150,
      },
      {
        'Header': 'SEGMENTO',
        'accessor': 'segment',
        'Cell': (props) => this.renderEditable(props),
        'width': 250,
      },
      {
        'Header': 'MODELO',
        'accessor': 'name',
        'Cell': (props) => {
          const verifiedId = !props.row.original.id;
          return this.renderEditable(props, verifiedId);
        },
      },
      {
        'Header': 'ESTADO',
        'accessor': 'state',
        'Cell': (cell) => {
          const id = cell.row.original.id;
          const state = cell.row.original.state;
          const created = cell.row.original.created;
          return (
            <select
              disabled={!created}
              onChange={(e) => this.onChangeSelectState(e, id)}
              style={{'width': '80%', 'fontSize': '15px', 'textAlign': 'center'}}
              value={state}
            >
              <option value="1">Activo</option>
              <option value="0">Inactivo</option>
            </select>
          );
        },
        'width': 150,
      },
    ],
    'selected': -1,
    'id': -1,
  };

  componentDidMount() {
    if (!hasAccessPermission(this.props.permissions, resources.VehiclesModels, scopes.See)) {
      this.props.push(paths.AccessDenied);
    }
    this.props.fetchVehiclesModel();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.vehicles !== this.props.vehicles) {
      const {vehicles} = this.props;
      this.setState({
        'data': cloneDeep(vehicles),
      });
    }
  }

  handleDeleteItem = () => {
    const {selected, data} = this.state;
    const dataFilter = data.filter((vehicle, index) => index !== selected);
    this.setState({
      'data': dataFilter,
      'selected': -1,
      'id': -1,
    });
  };

  /* eslint-disable max-statements */
  handleAdd = () => {
    const UNIT = 0.1;
    const {data, selected} = this.state;
    const after = data[selected + 1] ? parseFloat(data[selected + 1].idx) : null;
    const afterRound = roundNumber(after);
    const actual = data[selected] ? parseFloat(data[selected].idx) : 0;
    const actualRound = roundNumber(actual);
    const result = roundNumber(afterRound - UNIT) !== actualRound && actualRound + UNIT;

    if (result) {
      if (selected >= 0) {
        const data = [...this.state.data];
        const item = {
          'id': '',
          'name': '',
          'segment': '',
          'idx': `${Math.round(result * 10) / 10}`,
          'selected': -1,
        };
        data.splice(selected + 1, 0, item);
        this.setState({
          data,
        });
      } else {
        this.props.addMessageBoxError('Seleccione una fila');
      }
    } else {
      this.props.addMessageBoxError('No se puede agregar más autos en ese segmento');
    }
  };

  handleSave = () => {
    const {data} = this.state;
    if (!validateEmptyFields(data)) {
      const result = {};
      data.forEach((item) => {
        result[item.idx] = (result[item.idx] || 0) + 1;
      });
      const val = find(result, (number) => number > 1) || 1;
      if (val <= 1) {
        this.props.addVehiclesModels({'vehicles': this.state.data});
        this.setState({
          'selected': -1,
          'id': -1,
        });
      } else {
        this.props.addMessageBoxError('Existe valores repetidos en la columna de código');
      }
    } else {
      this.props.addMessageBoxError('Existe filas en blanco');
    }
  };

  onChangeSelectState = (event, id) => {
    const value = event.target.value;
    const data = {
      'state': value,
    };
    this.props.updateVehiclesModel({data}, id);
  };

  renderEditable = (cellInfo) => {
    const cellValue = this.state.data[cellInfo.row.index][cellInfo.column.id];
    return (
      <input
        className="input-editable"
        placeholder=""
        name="input"
        type="text"
        onChange={this.handleInputChange.bind(null, cellInfo)}
        value={cellValue}
      />
    );
  };

  handleInputChange = (cellInfo, event) => {
    const data = [...this.state.data];
    data[cellInfo.row.index][cellInfo.column.id] = event.target.value;
    this.setState({data});
  };

  render() {
    const {data, columns, id, selected} = this.state;
    return (
      <div>
        <Card raised fluid>
          <div className="container__vehicles">
            <div className="title-bar">
              <div className="title">
                <Header as="h2">Ingreso de familia Modelos</Header>
              </div>
            </div>
            <div className="vehicles--buttons">
              <Button disabled={id ? true : false} onClick={this.handleDeleteItem} color="red">
                QUITAR DE LA TABLA
              </Button>
              <Button onClick={this.handleAdd} color="blue">
                AGREGAR
              </Button>

              <Button onClick={this.handleSave} color="green">
                GUARDAR
              </Button>
            </div>
          </div>
        </Card>
        <Card raised fluid style={{'maxHeight': '38rem', 'overflow': 'auto'}}>
          <Table columns={columns} data={data} selected={selected} setState={this.setState.bind(this)}/>
        </Card>
      </div>
    );
  }
}

function Table({columns, data, selected, setState}) {
  // Use the state and functions returned from useTable to build your UI
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow,
  } = useTable({
    'columns': useMemo(() => columns),
    'data': useMemo(() => data),
  }, useSortBy,
  );

  // Render the UI for your table
  return (
    <table {...getTableProps()} className='vehicles-model-table' style={{'borderSpacing': '1px',
      'borderCollapse': 'separate'}}>
      <thead>
        {headerGroups.map((headerGroup) => (
          <tr {...headerGroup.getHeaderGroupProps()}>
            {headerGroup.headers.map((column) => (
              <th {...column.getHeaderProps(column.getSortByToggleProps())}>{column.render('Header')}
                {column.isSorted ?
                  column.isSortedDesc ?
                    <SortDownSvg /> :
                    <SortUpSvg /> : <SortSvg />
                }
              </th>
            ))}
          </tr>
        ))}
      </thead>
      <tbody {...getTableBodyProps()}>
        {rows.map((row, i) => {
          prepareRow(row);
          return (
            <tr {...row.getRowProps()} style={{
              'paddingTop': row.index === selected ? '5px' : '',
              'paddingBottom': row.index === selected ? '5px' : '',
              'background': row.index === selected ? '#31AB39' : '',
            }} onClick={ (e) => {
              const index = row ? row.index : -1;
              const id = row.original.id;
              setState({
                'selected': index,
                'id': id,
              });
            }
            }>
              {row.cells.map((cell) => {
                return <td {...cell.getCellProps()} style={{'padding': '10px'}}>{cell.render('Cell')}</td>;
              })}
            </tr>
          );
        })
        
        }
      </tbody>
    </table>
  );
}

const {fetchVehiclesModel,
  addMessageBoxError, deleteVehicleModel, addVehiclesModels, updateVehiclesModel, withRouter} = Actions;

const mapStateToProps = (state, ownProps) => {
  const {vehicles, loading} = state.vehiclesModels;

  return {
    'permissions': state.session.permissions,
    'push': ownProps.history.push,
    vehicles,
    loading,
  };
};

export default withRouter(connect(
  mapStateToProps,
  {
    fetchVehiclesModel,
    addMessageBoxError,
    deleteVehicleModel,
    addVehiclesModels,
    updateVehiclesModel,
  }
)(VehiclesModels));
